import { strings } from '../context/LanguageContext/strings'
import { util } from '../util'

const pushNotificationDataModel = {
    getInitialNotificationFilter: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'title',
            display_name: strings.SEARCH,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
            isNotFilterSideMenu: true,
        },
        {
            type: 'list',
            key: 'status',
            display_name: strings.STATUS,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            postUtil: ({ list, key }) => util.mapNotificationStatuses(list, key),
        },
        {
            type: 'range',
            key: 'date_range',
            display_name: strings.DATE,
            start_value: '',
            end_value: '',
            display_value: '',
            defaultDisplayValue: '',
            displayUtil: (startDate, endDate) => util.getDateRangeDisplayPill(startDate, endDate),
        },
        {
            type: 'list',
            key: 'region',
            display_name: strings.REGION,
            display_value: [],
            post_value: null,
            defaultDisplayValue: [],
            defaultPostValue: null,
            baseFilterList: [],
            postUtil: function ({ list, value }) {
                /** posted filter query values for region filter */
                return util.regionFilterQuery({
                    list,
                    value,
                    post_value: this.post_value,
                    baseFilterList: this.baseFilterList,
                })
            },
            displayUtil: function ({ list }) {
                return list.length === 0 ? strings.ALL_US_STATES : list
            },
        },
        {
            type: 'list',
            key: 'dma',
            display_name: 'DMA',
            display_value: [],
            post_value: null,
            defaultDisplayValue: [],
            defaultPostValue: null,
            displayUtil: function ({ list, value }) {
                return value.length ? list.concat(value) : list
            },
        },
        {
            type: 'string',
            key: 'send_to_nonspecified',
            display_name: strings.UNDEFINED_USERS,
            display_value: '',
            post_value: null,
            defaultDisplayValue: '',
            defaultPostValue: null,
            displayUtil: ({ value }) => value,
            postUtil: function ({ value }) {
                return value === strings.YES ? 'Y' : ''
            },
        },
        {
            type: 'list',
            key: 'created_by',
            display_name: strings.CREATED_BY,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            displayUtil: ({ list, value }) => {
                const updatedList = [...list]
                value &&
                    value.length &&
                    updatedList.indexOf(value) === -1 &&
                    updatedList.push(value)
                return updatedList
            },
            postUtil: config => util.getSuggestList(config),
        },
        {
            type: 'list',
            key: 'updated_by',
            display_name: strings.LAST_MODIFIED_BY,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            displayUtil: ({ list, value }) => {
                const updatedList = [...list]
                value &&
                    value.length &&
                    updatedList.indexOf(value) === -1 &&
                    updatedList.push(value)
                return updatedList
            },
            postUtil: config => util.getSuggestList(config),
        },
    ],
}

export default pushNotificationDataModel
